/**
 * @file 登录API
 * @author 小白
 */

import request from "@/utils/request";

export async function login(data) {
  return request.post("/openApi/login", data);
}

export async function logOut(data) {
  return request.delete("/user/logout", data);
}


// 学员登录 
export async function studentAccountlogin(data) {
  return request.post("/openApi/studentAccount/login", data);
}
